import { render } from "./buildings.vue?vue&type=template&id=1e0aa595&scoped=true"
import script from "./buildings.vue?vue&type=script&lang=js"
export * from "./buildings.vue?vue&type=script&lang=js"

import "./buildings.vue?vue&type=style&index=0&id=1e0aa595&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e0aa595"]])

export default __exports__